export default __webpack_public_path__ + "maps-examples-fly-to-thumbnail-480-deef9e5eccbe108005dc432bcb9f20b9.png";